import React, { useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { Layout } from "../../layouts/Layout";
import { ServicesDetailsFaq } from "../../components/ServicesDetails/ServicesDetailsFaq";
import { CHECK_ICON, SD_VIDEO_IMG, SERVICES_DETAILS01 } from "../../lib/assets";
import { ServicesDetailsWrapper } from "../../components/ServicesDetails/ServicesDetailsWrapper";
import { BrandSeven } from "../../components/Brand/BrandSeven";
import { HealthCheckModal } from "../../components/HealthCheck/HealthCheckModal";
import { getServiceBySlug } from "../../data/bookkeepingServices";

const ServicesDetailsPage = () => {
  const { slug } = useParams();
  const service = getServiceBySlug(slug);
  const [isHealthCheckOpen, setIsHealthCheckOpen] = useState(false);

  if (!service) {
    return <Navigate to="/services" replace />;
  }

  const { content } = service;

  return (
    <Layout breadcrumb={"Services"} title={service.label}>
      {/* services-details-area */}
      <ServicesDetailsWrapper hideContact hideTitle>
        <div className="services-details-wrap" key={service.slug}>
          <div className="services-details-thumb">
            <img src={SERVICES_DETAILS01} alt="" />
          </div>

          <div className="services-details-content">
            <h2 className="title">{content.title}</h2>
            <p>{content.intro}</p>
            <p>{content.description}</p>

            <div className="sd-inner-wrap">
              <div className="row align-items-center">
                <div className="col-56">
                  <div className="content">
                    <h3 className="title-two">{content.sectionTitle}</h3>
                    <p>{content.sectionText}</p>
                    <ul className="list-wrap">
                      {content.points.map((point) => (
                        <li key={point}>
                          <img src={CHECK_ICON} alt="" />
                          {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="col-44">
                  <div className="thumb">
                    <img src={SD_VIDEO_IMG} alt="" />
                  </div>
                </div>
              </div>
            </div>

            <p>{content.note}</p>
            <div className="company-benefit-wrap">
              <h2 className="title-two">{content.benefitTitle}</h2>
              <p>{content.benefitText}</p>

              {/* faq accordion */}
              <ServicesDetailsFaq items={content.faqs} idPrefix={service.slug} />
              {content.cta ? (
                <button
                  type="button"
                  className="btn"
                  onClick={() => setIsHealthCheckOpen(true)}
                >
                  {content.cta}
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </ServicesDetailsWrapper>

      {/* brand-area */}
      <BrandSeven />
      <HealthCheckModal
        isOpen={isHealthCheckOpen}
        onClose={() => setIsHealthCheckOpen(false)}
      />
    </Layout>
  );
};

export default ServicesDetailsPage;
